import { FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { ICAMSContact, ContactListConfig } from '../Contacts/ContactsModels';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_taskmodals2 = '#placeholder-for-taskmodals2',
    CAMSMainPage_LeftPanels = '#CAMSMainPage_LeftPanels',
    CAMSMainPage_RightPanels = '#CAMSMainPage_RightPanels',
    CAMSMainToolbar_Container = '#CAMSMainToolbar_Container',
    
    taskManagementAssignToModel = '#taskManagementAssignToModel',
    taskManagementAssignToModel_contactSearch = '#taskManagementAssignToModel_contactSearch',
    taskManagementAssignToModelCancelBtn = '#taskManagementAssignToModelCancelBtn',
    taskManagementAssignToModelCloseBtn = '#taskManagementAssignToModelCloseBtn',
    taskManagementAssignToModelSubmitBtn = '#taskManagementAssignToModelSubmitBtn',
}
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';

export class TaskAssignOptions {
    showUnassignBtn?: boolean;
    submitResponse?: boolean;
}

export class Tasks_Assign {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openAssignPanel = (camsKeys: Array<ICAMSKey>, options: TaskAssignOptions, callback: Function): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL = window.G_SITEFOLDERNAME + "/Tasks/AssignTasksView";
        let submitURL = window.G_SITEFOLDERNAME + "/Tasks/AssignTasks";
        let taskIDs: Array<string> = [];
        let taskGroupIDs: Array<string> = [];
        if (camsKeys != null) {
            camsKeys.forEach(c => {
                if (c.featureType == FeatureType.Task) {
                    taskIDs.push(c.code);
                }
                else {
                    taskGroupIDs.push(c.code);
                }
            });
        }
        let viewData = { taskIDs: taskIDs, taskGroupIDs: taskGroupIDs };

        // *******************************************************************************************************//
        // SUMBIT //
        Utilities.BlockUI();
        $('#placeholder-for-taskmodals2').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#taskAssignModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#taskAssignForm"));

            // Contact Btn
            $('#taskAssignModal_contactSearch').on('click', function () {
                Utilities.GetModal('#taskAssignModal', ModalAction.Hide);
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.RestrictToContactsWithAccounts = true;
                events.bus.publish(events.eventOpenContactsListView([false, btns, contactCallback]));

                function contactCallback(c: Array<ICAMSContact>) {
                    if (c != null) {
                        $('#taskAssignModal [name="AssignedTo"]').val(c[0].ContactRef);
                        $('#taskAssignModal [name="AssignedToListName"]').val(c[0].ListName);
                        $('#taskAssignModal [name="AssignedToType"]').val('');
                        $('#taskAssignModal [name="MainContact"]').val('');
                    }
                    Utilities.GetModal('#taskAssignModal', ModalAction.Show);
                }
            });

            $('#taskAssignModal [name="AssignedToType"]').on('change', function () {
                $('#taskAssignModal [name="AssignedToListName"]').val('');
                $('#taskAssignModal [name="AssignedTo"]').val('');
            });

            $('#taskAssignModal [name="MainContact"]').on('change', function () {
                $('#taskAssignModal [name="AssignedToListName"]').val('');
                $('#taskAssignModal [name="AssignedTo"]').val('');
                $('#taskAssignModal [name="AssignedToType"]').val('');
            });

            $('#taskAssignSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskAssignForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                var callbackData: ICAMSContact = {
                    ContactRef: $('#taskAssignModal [name="AssignedTo"]').val() as string,
                    ListName: $('#taskAssignModal [name="AssignedToListName"]').val() as string,
                    ContactType: $('#taskAssignModal [name="AssignedToType"]').val() as string,
                    ContactTypeDescr: $('#taskAssignModal [name="AssignedToType"]').find(":selected").text()
                };

                if ($('#taskAssignModal [name="MainContact"]').val() != "") {
                    callbackData.ContactRef = $('#taskAssignModal [name="MainContact"]').val() as string;
                    callbackData.ListName = $('#taskAssignModal [name="MainContact"]').find('option:selected').html() as string;
                }

                if (options.submitResponse == false) {
                    Utilities.GetModal('#taskAssignModal', ModalAction.Hide);
                    if (callback != null) callback(callbackData);
                    return;
                }
                else {
                    Utilities.BlockUI($("taskAssignModal .modal-content"));
                    let formData = new FormData(<any>$('#taskAssignForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: submitURL,
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Assigned task!');
                                    events.bus.publish(events.eventTaskUpdated(null));
                                    if (callback != null) callback(callbackData);
                                    Utilities.GetModal('#taskAssignModal', ModalAction.Hide);
                                }
                                else {
                                    toastr.error('Failed to assign task!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($("taskAssignModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            // Hide the unassign btn if a callback is provided
            if (options.showUnassignBtn != null) $('#taskUnAssignSubmitBtn').hide();
            $('#taskUnAssignSubmitBtn').on('click', function (evt) {
                var callbackData: ICAMSContact = { ContactRef: null, ListName: null, ContactType: null, ContactTypeDescr: null };

                if (options.submitResponse == false) {
                    Utilities.GetModal('#taskAssignModal', ModalAction.Hide);
                }
                else {
                    Utilities.BlockUI($("taskAssignModal .modal-content"));
                    let formData = new FormData(<any>$('#taskAssignForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: window.G_SITEFOLDERNAME + '/Tasks/UnAssignTasks',
                        data: formData,
                        success: function (result: IAPIResult) {

                            try {
                                if (result.success == true) {
                                    toastr.info('Unassigned task(s)!');
                                    events.bus.publish(events.eventTaskUpdated(null));
                                    if (callback != null) callback(callbackData);
                                    Utilities.GetModal('#taskAssignModal', ModalAction.Hide);
                                }
                                else {
                                    toastr.error('Failed to unassign task!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($("taskAssignModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            $('#taskAssignCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskAssignModal', ModalAction.Hide);
                if (callback != null) { callback(); }
            });
        });
    }

}




